




export default
  name: 'Title'

  components: {
  }

  data: () ->
    title: @$route.meta.title

  props:
    label:
      type: String
      default: ''
  mounted: () ->
    if @label
      @title = @label
